<template>
    <section>

        <aside ref="scrollContainer" @mouseover="stopScroll" @mouseleave="startScroll">
            <div class="programaCont" v-for="(item, index) in programs" :key="item.id">
                <div class="cardMain">
                    <div class="cardMainContent">
                        <div class="miniBadge">
                            <p>Programas</p>
                        </div>
                        <div class="cardMainInfo">
                            <h5>{{ item.program.title }}</h5>
                            <p><!--Umana x The Shift--></p>
                        </div>
                    </div>
                    <a href="/web-app?a=programa-individual" @click="setItem(item.program)">
                        <specialButtonMini class="botR" />
                    </a>

                    <div class="cardMainBG">
                        <img v-if="item.program.mobileImg === null" src="../../assets/prog1.png" alt="">
                        <img v-else :src="url + `/program-image/${item.program.id}/${item.program.mobileImg}`" alt="">
                    </div>
                </div>

                <div class="cardInfo">
                    <div class="miniBadgeBlack">
                        <p>Programas</p>
                    </div>
                    <div class="cardInfoInfo">
                        <h6>{{ item.program.title }}</h6>
                        <p><!--Umana x The Shift--> <br><br>
                            {{ item.program.shortDescr }} </p>
                    </div>


                    <a href="/web-app?a=programa-individual" @click="setItem(item.program)">
                        <specialButton :label="'ver más'" />
                    </a>
                </div>
            </div>
        </aside>
    </section>
</template>

<script>
import specialButton from '../specialButton.vue';
import specialButtonMini from '../specialButtonMini.vue';
import specialButtonMicro from '../specialButtonMicro.vue';
import { mapActions } from 'vuex';
import { url } from "@/global/index"
export default {
    data() {
        return {
            scrollInterval: null,
            scrollDirection: 1, // 1 para avanzar, -1 para retroceder
            scrollStep: 725, // Cantidad de píxeles por scroll
            scrollDelay: 3500, // Tiempo entre movimientos (en ms)
            url
        }
    },
    components: {
        specialButton,
        specialButtonMini,
        specialButtonMicro,
    },
    async created() {
        await this.getAllInfoFtr("feature")
    },
    computed: {
        programs() {
            return this.$store.getters['feature/data'];
        },
    },
    methods: {
        ...mapActions("feature", ["getAllInfoFtr"]),
        setItem(item) {
            localStorage.setItem('program', JSON.stringify(item))
        },
        startScroll() {
            this.stopScroll();
            const container = this.$refs.scrollContainer;

            const scroll = () => {
                container.scrollLeft += this.scrollDirection * this.scrollStep / 60; // Ajusta el paso para que sea más suave

                if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
                    this.scrollDirection = -1;
                } else if (container.scrollLeft <= 0) {
                    this.scrollDirection = 1;
                }

                this.scrollInterval = requestAnimationFrame(scroll);
            };

            this.scrollInterval = requestAnimationFrame(scroll);
        },
        stopScroll() {
            cancelAnimationFrame(this.scrollInterval);
        },
        updateScrollStep() {
            if (window.innerWidth <= 530) {
                this.scrollStep = 320;
            } else {
                this.scrollStep = 725;
            }
        },
    },
    mounted() {
        this.updateScrollStep();

        window.addEventListener("resize", this.updateScrollStep);

        this.startScroll();
    },
    beforeDestroy() {
        this.stopScroll();
    },

}
</script>

<style scoped>
section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.805556vw;
}

main {
    width: 95.625vw;
    height: 52.986111vw;
    border-radius: 2.083333vw;
    padding: 1.736111vw;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #E3E3E9;
}

.badge {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.041667vw;
    padding: .763889vw 2.083333vw;
    position: relative;
    z-index: 2;
}

.badge svg {
    width: 2.083333vw;
    height: 2.361111vw;
}

.badge p {
    color: #464D5B;
    font-family: Manrope;
    font-size: 1.388889vw;
    font-style: normal;
    font-weight: 500;
    line-height: 1.111111vw;
}

.badge p strong {
    color: #464D5B;
    font-family: "SharFtrotesk-Medium25";
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
}

main>span {
    width: 22.013889vw;
    color: #464D5B;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    position: absolute;
    top: 13.402778vw;
    left: 12.916667vw;
}

main>h4 {
    color: var(--white, #FFF);
    font-family: "Kemio";
    font-size: 15.972222vw;
    font-style: normal;
    font-weight: 400;
    line-height: 25.694444vw;
    text-transform: uppercase;
}

.pos1 {
    position: absolute;
    top: 18.333333vw;
    left: 10.694444vw;
    z-index: 3;
}

.pos2 {
    position: absolute;
    top: 30.486111vw;
    left: 45.972222vw;
    z-index: 2;
}

.pos3 {
    position: absolute;
    top: 30.625vw;
    left: 54.791667vw;
    z-index: 0;
}

.pos4 {
    position: absolute;
    top: 26.458333vw;
    right: 6.388889vw;
    z-index: 0;
}

main>img {
    width: 31.875vw;
    height: 52.152778vw;

    position: absolute;
    left: 34.027778vw;
    right: 29.6875vw;
    bottom: 0;
    z-index: 1;
}

ul {
    display: flex;
    flex-direction: row;
    width: 95.625vw;
    padding: 0vw 2.083333vw;
    justify-content: space-between;
    align-items: center;
    list-style: none;
}

li {
    display: flex;
    align-items: center;
    gap: 1.180556vw;
}

li p {
    color: var(--Text, #464D5B);
    font-family: "SharFtrotesk-Medium25";
    font-size: .694444vw;
    font-style: normal;
    line-height: 2.083333vw;
    letter-spacing: .277778vw;
    text-transform: uppercase;
}

li svg {
    width: 2.083333vw;
    height: 2.638889vw;
}

aside {
    width: 100%;
    height: 30vw;
    display: flex;
    flex-direction: row;
    gap: 1.111111vw;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
}

aside {
    will-change: scroll-position;
}

.cardMainBG {
    will-change: transform;
}

aside::-webkit-scrollbar {
    display: none;
}

ul::-webkit-scrollbar {
    display: none;
}


aside>div {
    scroll-snap-align: center;
}

.cardMain {
    min-width: 29.097222vw;
    height: 100%;
    border-radius: 2.083333vw;
    padding: 1.388889vw 1.388889vw;
    position: relative;
    border-radius: 2.083333vw;
    overflow: hidden;
}

.cardMainContent {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 7.361111vw;
    height: 100%;
}

.miniBadge p {
    color: var(--white, #FFF);
    text-align: center;
    font-family: Manrope;
    font-size: 1.388889vw;
    font-style: normal;
    font-weight: 400;
    line-height: 1.388889vw;
}

.miniBadge {
    display: inline-flex;
    width: fit-content;
    padding: 1.041667vw 2.083333vw;
    flex-direction: column;
    align-items: flex-start;
    gap: 2.083333vw;
    border: .069444vw solid var(--white, #FFF);
    border-radius: 2.083333vw;

}

.miniBadgeBlack p {
    color: #464D5B;
    text-align: center;
    font-family: Manrope;
    font-size: 1.388889vw;
    font-style: normal;
    font-weight: 400;
    line-height: 1.388889vw;
}

.miniBadgeBlack {
    display: inline-flex;
    width: fit-content;
    padding: 1.041667vw 2.083333vw;
    flex-direction: column;
    align-items: flex-start;
    gap: 2.083333vw;
    border: .069444vw solid #464D5B;
    border-radius: 2.083333vw;

}

.cardMainBG {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 0;
    clip-path: polygon(0% 93.056%, 0% 6.944%, 0% 6.944%, 0.094% 5.818%, 0.365% 4.749%, 0.799% 3.753%, 1.381% 2.843%, 2.097% 2.034%, 2.931% 1.34%, 3.87% 0.775%, 4.897% 0.354%, 5.999% 0.091%, 7.16% 0%, 92.84% 0%, 92.84% 0%, 94.001% 0.091%, 95.103% 0.354%, 96.131% 0.775%, 97.069% 1.34%, 97.903% 2.034%, 98.619% 2.843%, 99.201% 3.753%, 99.635% 4.749%, 99.906% 5.818%, 100% 6.944%, 100% 75.886%, 100% 75.886%, 99.906% 77.013%, 99.635% 78.081%, 99.201% 79.078%, 98.619% 79.987%, 97.903% 80.797%, 97.069% 81.491%, 96.131% 82.055%, 95.103% 82.477%, 94.001% 82.74%, 92.84% 82.831%, 90.269% 82.831%, 90.269% 82.831%, 89.108% 82.921%, 88.006% 83.185%, 86.979% 83.606%, 86.04% 84.17%, 85.206% 84.865%, 84.49% 85.674%, 83.908% 86.584%, 83.474% 87.58%, 83.203% 88.649%, 83.109% 89.775%, 83.109% 93.056%, 83.109% 93.056%, 83.015% 94.182%, 82.744% 95.251%, 82.31% 96.247%, 81.728% 97.157%, 81.012% 97.966%, 80.178% 98.66%, 79.239% 99.225%, 78.212% 99.646%, 77.111% 99.909%, 75.949% 100%, 7.16% 100%, 7.16% 100%, 5.999% 99.909%, 4.897% 99.646%, 3.87% 99.225%, 2.931% 98.66%, 2.097% 97.966%, 1.381% 97.157%, 0.799% 96.247%, 0.365% 95.251%, 0.094% 94.182%, 0% 93.056%);
}

.cardMainBG img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: top;
}

.cardMainInfo {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.cardMainInfo h5 {
    color: var(--white, #FFF);
    font-family: Manrope;
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 400;
    line-height: 2.777778vw;
}

.cardMainInfo p {
    color: var(--white, #FFF);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: 1.041667vw;
}

.botR {
    position: absolute;
    right: .208333vw;
    bottom: .486111vw;
    z-index: 2;
}

.cardInfo {
    min-width: 23.125vw;
    height: 100%;
    background-color: #E3E3E9;
    border-radius: 2.083333vw;
    padding: 1.388889vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1.388889vw;
}

.cardInfoInfo {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.cardInfoInfo h6 {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.cardInfoInfo p {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    height: 100%;
    height: fill;
}

.programaCont {
    display: flex;
    flex-direction: row;
    gap: 1.111111vw;
}

h3 {
    display: none;
}

.textBox {
    display: none;
}

.coverImage {
    display: none;
}

.svgDeco {
    display: none;
}

@media (max-width: 530px) {
    @media (max-width: 530px) {
        * {
            transition: none !important;
            animation: none !important;
        }
    }

    section {
        gap: 0;
    }

    main {
        position: sticky;
        top: 2.325581vw;
        border-radius: 6.976744vw;

        padding: 4.651163vw;
        width: 93.023256vw;
        height: 98vh;
        justify-content: space-between;

    }

    .pc {
        display: none;
    }

    .badge {
        position: relative;

        gap: 3.488372vw;
        padding: 0;
    }

    .badge svg {
        width: 6.976744vw;
        height: 7.906977vw;
    }

    .badge p {
        font-size: 4.651163vw;
        line-height: 5.116279vw;
    }

    .badge p strong {
        font-size: 9.302326vw;
    }

    .pos1,
    .pos2,
    .pos3 {
        display: none;
    }

    main>img {
        display: none;
    }

    main>span {
        font-size: 3.488372vw;
        text-align: center;
        width: 83.72093vw;
        left: 4.651163vw;
        bottom: 25.581395vw;
        top: auto;
    }

    .pos4 {

        position: relative;
        top: 0;
        right: 0;
    }

    .textBox {
        display: inline;
        position: absolute;
        top: 20.697674vw;
        left: 4.651163vw;
        height: 124.883721vw;
        width: 83.72093vw;
    }

    h3 {
        display: inline;

        color: var(--purple, #B359F8);
        font-family: Kemio;
        font-size: 32.55814vw;
        font-style: normal;
        font-weight: 400;
        line-height: 80%;
        text-transform: uppercase;
        position: absolute;
        top: 33.72093vw;
        left: -19.069767vw;
        transform: rotate(90deg);
    }

    h3 span {
        opacity: 0;
        user-select: none;
    }

    h3 strong {
        color: #464D5B;
        font-weight: 400;
        position: relative;
    }

    ul,
    aside {
        z-index: 3;
        background-color: #fff;
    }

    .coverImage {
        display: inline;
        width: 93.023256vw;
        height: 100vh;
        object-fit: contain;
        object-position: right;
        z-index: 1;
        position: sticky;
        top: 0vw;
    }

    ul {
        height: 22.325581vw;
        justify-content: flex-start;
        gap: 16.27907vw;
        overflow-x: scroll;
        padding: 0 6.976744vw;
    }

    li svg {
        width: 6.976744vw;
        height: 8.837209vw;
    }

    li {
        gap: 4.186047vw;
    }

    li p {
        width: max-content;

        font-size: 2.325581vw;
        line-height: 6.976744vw;
    }

    .svgDeco {
        display: flex;
    }

    .programaCont {
        display: flex;
        flex-direction: column;
        gap: 4.651163vw;
    }

    aside {
        height: auto;
        padding: 4.651163vw;
        gap: 4.651163vw;
    }

    .cardInfo {
        min-width: 90.697674vw;
        height: 51.395349vw;
        padding: 4.651163vw;
        border-radius: 6.976744vw;
    }

    .cardInfo .miniBadgeBlack {
        display: none;
    }

    .cardInfoInfo h6 {
        display: none;
    }

    .cardMain {
        height: 82.325581vw;
        width: 93.023256vw;
        padding: 4.651163vw;
    }

    .cardMainBG {
        clip-path: polygon(0% 90.683%, 0% 9.317%, 0% 9.317%, 0.101% 7.806%, 0.394% 6.372%, 0.863% 5.035%, 1.492% 3.814%, 2.265% 2.729%, 3.166% 1.798%, 4.179% 1.04%, 5.288% 0.475%, 6.478% 0.122%, 7.732% 0%, 92.268% 0%, 92.268% 0%, 93.522% 0.122%, 94.712% 0.475%, 95.821% 1.04%, 96.834% 1.798%, 97.735% 2.729%, 98.508% 3.814%, 99.137% 5.035%, 99.606% 6.372%, 99.899% 7.806%, 100% 9.317%, 100% 74.4%, 100% 74.4%, 99.908% 75.768%, 99.643% 77.065%, 99.219% 78.275%, 98.65% 79.379%, 97.951% 80.361%, 97.136% 81.204%, 96.219% 81.89%, 95.215% 82.401%, 94.139% 82.72%, 93.004% 82.831%, 93.004% 82.831%, 91.869% 82.943%, 90.792% 83.268%, 89.788% 83.788%, 88.872% 84.484%, 88.057% 85.338%, 87.357% 86.332%, 86.788% 87.447%, 86.364% 88.665%, 86.099% 89.968%, 86.007% 91.337%, 86.007% 91.337%, 85.914% 92.732%, 85.644% 94.059%, 85.212% 95.299%, 84.633% 96.435%, 83.921% 97.447%, 83.091% 98.316%, 82.157% 99.025%, 81.135% 99.554%, 80.039% 99.885%, 78.883% 100%, 7.732% 100%, 7.732% 100%, 6.478% 99.878%, 5.288% 99.525%, 4.179% 98.96%, 3.166% 98.202%, 2.265% 97.271%, 1.492% 96.186%, 0.863% 94.965%, 0.394% 93.628%, 0.101% 92.194%, 0% 90.683%);
    }

    .botR {
        right: .116279vw;
        bottom: 1.26279vw;

    }

    .cardInfoInfo p {
        font-size: 3.488372vw;
    }

    .miniBadge {
        padding: 3.488372vw 6.976744vw;
        border-radius: 6.976744vw;
    }

    .miniBadge p {
        font-size: 4.651163vw;
        line-height: 4.651163vw;
    }

    .cardMainContent {
        gap: 4.361111vw;
    }

    .cardMainInfo {
        gap: 4.651163vw;
    }

    .cardMainInfo h5 {
        font-size: 9.302326vw;
        line-height: 9.302326vw;
    }

    .cardMainInfo p {
        font-size: 3.488372vw;
        line-height: 3.488372vw;
    }
}
</style>